import type { LocationSuggestion } from '@xing-com/crate-jobs-hooks';
import { BodyCopy, Meta } from '@xing-com/typography';

export const locationRenderer =
  (locationInput: string) =>
  (item: LocationSuggestion): React.ReactNode => {
    const { name, meta } = item;
    const position = name.toLowerCase().indexOf(locationInput.toLowerCase());

    let formattedName: React.ReactNode = name;
    if (position >= 0) {
      const left = name.substring(0, position);
      const middle = name.substring(position, position + locationInput.length);
      const right = name.substring(position + locationInput.length);

      formattedName = (
        <>
          {left}
          <strong>{middle}</strong>
          {right}
        </>
      );
    }

    return (
      <>
        <BodyCopy ellipsis noMargin>
          {formattedName}
        </BodyCopy>
        <Meta size="xsmall" ellipsis noMargin>
          {meta}
        </Meta>
      </>
    );
  };
